// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_1ebId","popoverWrapper":"_1ebId","root":"_1yr7V"};